export default {
    getGlobalCommendCourse: {
        url: '/crm/commendcourse/getGlobalCommendCourse',
        method: 'get'
    },
    signUp: {
        url: '/crm/studentsignup/save',
        method: 'post'
    },
    actSignUp: {
        url: '/mps/activityspellgroup/joinSpellActivity',
        method: 'post'
    }
}
